import { VideoItem } from '../types/getVideo';

export interface VideoSubtitleTrackData {
  default: boolean;
  kind: 'captions';
  file: string;
  label: string;
}

export const subtitleTextToVtt = (text: string): string => {
  const normalized = text
    .replace(/^\uFEFF/, '')
    .replace(/\r\n?/g, '\n')
    .trim();
  if (/^WEBVTT(?:\s|$)/.test(normalized)) {
    return normalized;
  }

  const converted = normalized.replace(/^(\d{2,}:\d{2}:\d{2}),(\d{3})([ \t]+-->[ \t]+\d{2,}:\d{2}:\d{2}),(\d{3})/gm, '$1.$2$3.$4');
  return `WEBVTT\n\n${converted}`;
};

export const getSubtitleTracks = (
  videoData: Pick<VideoItem, 'attributes' | 'subtitles' | 'subtitle'> | null,
  createTextTrackUrl: (text: string) => string
): VideoSubtitleTrackData[] => {
  const showInPortal = videoData?.attributes?.some(
    (attribute) => attribute.moduleCode === 'media' && attribute.key === 'show_in_portal' && attribute.value === 'true'
  );

  if (!showInPortal) {
    return [];
  }

  const tracks: VideoSubtitleTrackData[] =
    videoData?.subtitles
      ?.filter((track) => track.videoSubtitlesURL?.trim())
      .map((track) => ({
        default: false,
        kind: 'captions',
        file: track.videoSubtitlesURL,
        label: track.language,
      })) || [];

  const generated = videoData?.subtitle;
  if (
    generated?.subtitleStatus === 'COMPLETED' &&
    generated.text?.trim() &&
    !tracks.some((track) => track.label.toLowerCase() === generated.language?.toLowerCase())
  ) {
    tracks.push({
      default: false,
      kind: 'captions',
      file: createTextTrackUrl(subtitleTextToVtt(generated.text)),
      label: generated.language || 'Subtitles',
    });
  }

  if (tracks.length) {
    tracks[0].default = true;
  }
  return tracks;
};
